import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {  MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
// Import  TranslateService
import { TranslateService } from '@ngx-translate/core';
import { getDeepCopyOfObject } from 'app/shared/utilities/utility-methods.utility';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { FilterDateInterface, FilterInterface, SiteFilterInterface } from '../../models';
import { SiteFilterService } from '../../services/site-filter.service';

@Component({
  selector: 'cz-site-filters',
  templateUrl: './site-filters.component.html',
  styleUrls: ['./site-filters.component.scss'],
})
export class SiteFiltersComponent implements OnInit, OnDestroy {

  @Input() public showContent: boolean;

  public clearAllSiteFilters: boolean = false;

  public readonly siteFilter$: BehaviorSubject<Readonly<SiteFilterInterface>>;

  private readonly destroy$: Subject<boolean> = new Subject<boolean>();

  private dateFilterActive: boolean;
// Inject TranslateService
  constructor(private readonly _siteFilterService: SiteFilterService,
              private _snackBar: MatSnackBar,
              private _translateService: TranslateService,
              private _router: Router) {
    this.siteFilter$ = new BehaviorSubject<Readonly<SiteFilterInterface>>(undefined);
  }

  public ngOnInit(): void {

    this._siteFilterService.getFilter()
    .pipe(
      takeUntil(this.destroy$))
      .subscribe((siteFilter: SiteFilterInterface) => {
        if(siteFilter && siteFilter.dateFilter && siteFilter.filters) {
          if(siteFilter.dateFilter.isActive || this.isAnyFilterActive(siteFilter)) {
            this.clearAllSiteFilters = true;
          } else {
            this.clearAllSiteFilters = false;
          }
        }
        this.siteFilter$.next(siteFilter);
      });
  }

  public ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  public updateFilterDates(filterDates: FilterDateInterface): void {
    const route: string = this._router.url;
    if (route === '/users/system-users') {
      // Static text to Language Variable updated
      this.showSnackBar(this._translateService.instant('$snack_bar_retrieving_users'));
    }
    const filter: SiteFilterInterface = getDeepCopyOfObject(this.siteFilter$.value);

    filter.dateFilter = filterDates;

    if(filterDates.isActive || this.isAnyFilterActive(filter)) {
      this.clearAllSiteFilters = true;
    } else {
      this.clearAllSiteFilters = false;
    }

    this._siteFilterService.updateFilter(filter);
  }

  public updateFilterMenu(filterMenuData: FilterInterface): void {
    const route: string = this._router.url;
    if (route === '/users/system-users') {
      // Static text to Language Variable updated
      this.showSnackBar(this._translateService.instant('$snack_bar_retrieving_users'));
    }
    const filter: SiteFilterInterface = getDeepCopyOfObject(this.siteFilter$.value);

    filter.filters.forEach((filterMenu: FilterInterface) => {
      if(filterMenuData.id === filterMenu.id) {
        filterMenu.items = filterMenuData.items;
        filterMenu.isSelected = filterMenuData.isSelected;
      }
    });

    if(this.dateFilterActive || this.isAnyFilterActive(filter)) {
      this.clearAllSiteFilters = true;
    } else {
      this.clearAllSiteFilters = false;
    }

    this._siteFilterService.updateFilter(filter);
  }

  public clearAllFilters(): void {
    const route: string = this._router.url;
    if (route === '/users/system-users') {
      // Static text to Language Variable updated
      this.showSnackBar(this._translateService.instant('$snack_bar_retrieving_users'));
    }
    const filter: SiteFilterInterface = getDeepCopyOfObject(this.siteFilter$.value);

    filter.dateFilter.startDate = undefined;
    filter.dateFilter.endDate = undefined;
    filter.dateFilter.isActive = false;

    for(let i: number = 0; i < filter.filters.length; i = i + 1) {
      for(let f: number = 0; f < filter.filters[i].items.length; f = f + 1) {
        filter.filters[i].items[f].isSelected = false;
      }
    }
    this.clearAllSiteFilters = false;

    this._siteFilterService.updateFilter(filter);
  }

  private isAnyFilterActive(siteFilterData: SiteFilterInterface): boolean {
    return siteFilterData.filters.filter((filter: FilterInterface) => filter.isSelected).length > 0;
  }

  /**
   * generic snack bar notifier to notify users of specific events
   * @param message message to display in snackbar
   */
  private showSnackBar(message: string): void {
    this._snackBar.open(message, undefined, {
      duration: 5000,
    });
  }
}
